import { BaseModel, type RelationConfig } from './base';

import { FormItem } from './formItem';
import { ServiceForm } from './serviceForm';

// Enums

export enum FormPermission {
  open = 0,
  secure = 1,
}

export const FormPermissionLabels: Record<FormPermission, string> = {
  [FormPermission.open]: 'general.open',
  [FormPermission.secure]: 'form.secure',
};

// Helper Classes

export class AnnotatedStamp extends BaseModel {
  code!: string;

  override objectID(): string | null {
    return this.code ?? null;
  }
}

export class AnnotatedColour extends BaseModel {
  code!: string;

  override objectID(): string | null {
    return this.code ?? null;
  }
}

export class AnnotatedBackground extends BaseModel {
  code!: string;

  override objectID(): string | null {
    return this.code ?? null;
  }
}

export class AnnotatedOptions extends BaseModel {
  code!: string;
  stamps!: AnnotatedStamp[];
  colours!: AnnotatedColour[];
  backgrounds!: AnnotatedBackground[];

  static override relations(): RelationConfig {
    return {
      stamps: { type: AnnotatedStamp },
      colours: { type: AnnotatedColour },
      backgrounds: { type: AnnotatedBackground },
    };
  }

  override objectID(): string | null {
    return this.code ?? null;
  }
}

// Main Model

export class Form extends BaseModel {
  idForm!: number;
  permission!: FormPermission;
  items!: FormItem[];
  services!: ServiceForm[];

  static override relations(): RelationConfig {
    return {
      items: { type: FormItem },
      services: { type: ServiceForm },
    };
  }

  override objectID(): string | null {
    const id = Number(this.idForm);

    return id > 0 ? id.toString() : null;
  }
}
